// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"783":"ff912b5e","956":"9fe32ed2"}[chunkId] + ".chunk.css";
};